module.exports = __webpack_public_path__ + "img/PNG.041a244b.jpg";